(function () {
  function updateNavState(gallery) {
    var track = gallery.querySelector('[data-category-track]');
    var prevBtn = gallery.querySelector('[data-category-prev]');
    var nextBtn = gallery.querySelector('[data-category-next]');

    if (!track) return;

    var maxScroll = track.scrollWidth - track.clientWidth;
    var canScrollPrev = track.scrollLeft > 4;
    var canScrollNext = track.scrollLeft < maxScroll - 4;

    gallery.classList.toggle('category-strip__gallery--can-scroll-prev', canScrollPrev);

    if (prevBtn) prevBtn.disabled = !canScrollPrev;
    if (nextBtn) nextBtn.disabled = !canScrollNext;
  }

  function scrollAmount(track) {
    var tile = track.querySelector('.category-strip__tile');
    if (!tile) return 280;

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || 0) || 16;
    return tile.getBoundingClientRect().width + gap;
  }

  function initCategoryStrips() {
    document.querySelectorAll('[data-category-strip]').forEach(function (gallery) {
      if (gallery.dataset.categoryReady === 'true') return;

      var track = gallery.querySelector('[data-category-track]');
      var prevBtn = gallery.querySelector('[data-category-prev]');
      var nextBtn = gallery.querySelector('[data-category-next]');

      if (!track) return;

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount(track), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(track), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', function () {
        updateNavState(gallery);
      });

      window.addEventListener('resize', function () {
        updateNavState(gallery);
      });

      updateNavState(gallery);
      gallery.dataset.categoryReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategoryStrips);
  } else {
    initCategoryStrips();
  }

  document.addEventListener('shopify:section:load', initCategoryStrips);
})();
